import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { useCredits } from '../../contexts/CreditsContext';

/**
 * Bannière persistante affichée quand le solde atteint 0.
 *
 * Pilotée par `depleted` (balance <= 0) : elle apparaît dès qu'un débit met le
 * solde à plat (les agents IA sont alors mis en pause côté serveur) et disparaît
 * automatiquement dès qu'un `credits:updated` ramène le solde > 0 (rechargement
 * admin) — sans rechargement de page.
 */
export default function CreditDepletedBanner() {
  const { depleted } = useCredits();

  return (
    <AnimatePresence>
      {depleted && (
        <motion.div
          initial={{ opacity: 0, height: 0, marginBottom: 0 }}
          animate={{ opacity: 1, height: 'auto', marginBottom: 16 }}
          exit={{ opacity: 0, height: 0, marginBottom: 0 }}
          transition={{ duration: 0.25 }}
          role="alert"
          className="overflow-hidden"
        >
          <div className="flex items-start gap-3 rounded-custom border border-red-500/50 bg-red-500/10 px-4 py-3">
            <AlertTriangle className="mt-0.5 flex-shrink-0 text-red-400" size={20} />
            <p className="text-sm text-red-200 leading-snug">
              <span className="font-semibold text-red-100">Vos crédits sont épuisés. </span>
              Vos agents IA sont en pause et ne répondent plus automatiquement jusqu'au
              rechargement.
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
